<template>
	<div id="controleContrato">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="6">
				<a-row>
					<span>Cliente:</span>
				</a-row>
				<a-row>
					<a-select
						show-search
						option-filter-prop="children"
						style="width: 95%"
						@change="handleClienteChange"
						:disabled="loading"
						:value="valueCliente"
						:allowClear="(valueCliente!=null && valueCliente!=undefined)"
						>
						<a-select-option v-for="cli in clientes" :key="cli.idCliente">
							{{cli.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>Usuário:</span>
				</a-row>
				<a-row>
					<a-select
						style="width: 95%"
						@change="handleUsuarioChange"
						:disabled="loading"
						:value="valueUsuario"
						:allowClear="(valueUsuario!=null && valueUsuario!=undefined)"
						>
						<a-select-option v-for="usu in usuarios" :key="usu.idUsuario">
							{{usu.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>Perfil:</span>
				</a-row>
				<a-row>
					<a-select 					
						style="width: 95%"
						@change="handlePerfilTribunalChange"
						:disabled="loading"
						:value="valuePerfilTribunal"
						:allowClear="(valuePerfilTribunal!=null && valuePerfilTribunal!=undefined)"
						>
						<a-select-option v-for="perfilTribunal in perfisTribunal" :key="perfilTribunal.idPerfilTribunal">
							{{perfilTribunal.nome}}
						</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="6">
				<a-row>
					<span>Status Monitoramento:</span>
				</a-row>
				<a-row>
					<a-select
						show-search
						option-filter-prop="children"
						style="width: 95%"
						@change="handleStatusMonitoramentoChange"
						:disabled="loading"
						:value="valueStatusMonitoramento"
						:allowClear="(valueStatusMonitoramento!=null && valueStatusMonitoramento!=undefined)"
						>
						<a-select-option value="0">AGUARDANDO APROVAÇÃO DO GESTOR</a-select-option>
						<a-select-option value="1">PENDENTE ENVIO CADASTRO</a-select-option>
						<a-select-option value="2">AGUARDANDO HOMOLOGAÇÃO DE PRODUTO</a-select-option>
						<a-select-option value="3">PENDENTE ENVIO CADASTRO DE CREDENCIAIS</a-select-option>
						<a-select-option value="4">AGUARDANDO HOMOLOGAÇÃO DAS CREDENCIAIS</a-select-option>
						<a-select-option value="5">HOMOLOGADO</a-select-option>
						<a-select-option value="6">REJEITADO</a-select-option>
						<a-select-option value="7">PENDENTE ENVIO ALTERAÇÃO</a-select-option>
						<a-select-option value="8">AGUARDANDO HOMOLOGAÇÃO DE ALTERAÇÃO</a-select-option>
						<a-select-option value="9">PENDENTE ENVIO INATIVAÇÃO</a-select-option>
						<a-select-option value="10">AGUARDANDO HOMOLOGAÇÃO DE INATIVAÇÃO</a-select-option>
						<a-select-option value="11">DESATIVADO</a-select-option>
						<a-select-option value="12">NÃO APROVADO GESTOR</a-select-option>
						<a-select-option value="99">ERRO</a-select-option>
					</a-select>
				</a-row>
			</a-col>
			<a-col :span="2" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					type="primary"
					@click.prevent="pesquisar(false)"
					:disabled="loading"
				>Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table              				
				style="width: 100%;"
				:columns="columnsAgrupCliente"
				:rowKey="record => record.id"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<a-table
					slot="expandedRowRender"
					slot-scope="record"					
					:columns="columnsAgrupUsuario"
					:rowKey="record => record.$id"
					:dataSource="record.subListaUsario"
					:pagination="false"
					size="middle"
				>
					<a-table
						slot="expandedRowRender"
						slot-scope="record"						
						:columns="columnsAgrupPerfilTribunal"
						:rowKey="record => record.$id"
						:dataSource="record.subListaPerfilTribunal"
						:pagination="false"
						size="middle"
					>
						<a-table
							slot="expandedRowRender"
							slot-scope="record"
							style="background-color: #ececec;"
							:columns="columnsContrato"
							:rowKey="record => record.$id"
							:dataSource="record.subListaContrato"            
							:pagination="false"
							size="middle"
						>
							<template
								slot="dataCadastro"
								slot-scope="dataCadastro, record"
							>	{{formatarDataLocal(record.dataCadastro, true, 'DD/MM/YYYY HH:mm:ss')}}
							</template>
							<template
								slot="dataUltimaAlteracao"
								slot-scope="dataUltimaAlteracao, record"
							>	{{formatarDataLocal(record.dataUltimaAlteracao, true, 'DD/MM/YYYY HH:mm:ss')}}
							</template>	
							<template slot="editar" slot-scope="editar, record">
								<div>
									<a-tooltip  v-if="record.statusMonitoramento == 4" style="padding-right: 8px;">
										<template slot="title">Rejeitar</template>
										<a-icon 
											type="form" 
											class="cursor"
											@click.prevent="handleOkRejeitar(record)"/>
									</a-tooltip>
									<a-tooltip style="padding-right: 8px;">
										<template slot="title">Histórico</template>
										<a-icon 
											type="history" 
											class="cursor"
											@click.prevent="handleOKHistorico(record)"/>
									</a-tooltip>
									<a-tooltip v-if="record.statusMonitoramento == 6" style="padding-right: 8px;">
										<template slot="title">Reprocessar</template>
										<a-icon 
											type="sync" 
											class="cursor"
											@click.prevent="handleOkReprocessar(record)"/>
									</a-tooltip>
									<a-tooltip v-if="record.statusMonitoramento == 99" style="padding-right: 8px;">
										<template slot="title">Setar Inválido</template>
										<a-icon 
											type="stop" 
											class="cursor"
											@click.prevent="handleOkSetErroLogin(record)"/>
									</a-tooltip>
								</div>
							</template>
						</a-table>
					</a-table>
				</a-table>
			</a-table>		
		</a-row>

		<modal-component
			class="modal-component"
			title="Histórico Fontes"
			ref="modalHistoricoFontes"
			width="80%"			
			:maskClosable="false"
		>
			<a-row>
				<a-table
					:columns="columnsHistoricoContrato"
					:rowKey="record => record.idContratoHistorico"
					:dataSource="dataHistorico"
					:loading="{spinning:loading, tip:'Carregando...'}"
					:pagination="paginationHistorico"
					@change="handleTableHistoricoChange"
					:scroll="windowSizeScroll"
					size="small"
				>
					<template slot="status" slot-scope="status, record">					
						<a-icon type="check-circle" class="sucess" v-if="record.status"/>
						<a-icon type="close-circle" class="danger" v-else/>					
					</template>
					<template slot="dataHistorico" slot-scope="dataHistorico, record">
						{{formatarDataLocal(record.dataHistorico, true, 'DD/MM/YYYY HH:mm:ss')}}
					</template>
					<template slot="dataUltimaAlteracao" slot-scope="dataUltimaAlteracao, record">
						{{formatarDataLocal(record.dataUltimaAlteracao, true, 'DD/MM/YYYY HH:mm:ss')}}
					</template>	
					<template slot="image64Autenticacao" slot-scope="image64Autenticacao, record">
						{{record.image64Autenticacao}}
					</template>	
				</a-table>				
			</a-row>
			<!-- <span slot="buttons">
				<a-row type="flex" align="middle">					
					<a-col :span="24">
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button key="back" class="fontePOL-form-button" @click.prevent="handleCancel">Retornar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span> -->
		</modal-component>
	</div>
</template>

<script>
import IntimacaoWebApi from "@/API/intimacaoWebApi";
import moment from "moment";
import ModalComponent from "@/components/ModalComponent";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columnsAgrupCliente = [
	{    
		title: "Cliente",
		dataIndex: "nomeCliente",
		align: "left",
		scopedSlots: { customRender: "nomeCliente" },
		width: "100%",
		sorter: (a, b) => a.nomeCliente.localeCompare(b.nomeCliente)
	},
];

const columnsAgrupUsuario = [
	{    
		title: "Usuário",
		dataIndex: "nomeUsuario",
		align: "left",
		scopedSlots: { customRender: "nomeUsuario" },
		width: "100%",
		sorter: (a, b) => a.nomeUsuario.localeCompare(b.nomeUsuario)
	},
];

const columnsAgrupPerfilTribunal = [
	{    
		title: "Perfil",
		dataIndex: "nomePerfilTribunal",
		align: "left",
		scopedSlots: { customRender: "nomePerfilTribunal" },
		width: "100%",
		sorter: (a, b) => a.nomePerfilTribunal.localeCompare(b.nomePerfilTribunal)
	},
];

const columnsContrato = [
	{    
		title: "Status",
		dataIndex: "descStatus",
		align: "left",
		scopedSlots: { customRender: "descStatus" },
		width: "6%",
		sorter: (a, b) => a.descStatus.localeCompare(b.descStatus)
	},
	{    
		title: "Fonte",
		dataIndex: "siglaKurier",
		align: "left",
		scopedSlots: { customRender: "siglaKurier" },
		width: "15%",
		sorter: (a, b) => a.siglaKurier.localeCompare(b.siglaKurier)
	},
	{    
		title: "Mensagem",
		dataIndex: "mensagemPol",
		align: "left",
		scopedSlots: { customRender: "mensagemPol" },
		width: "25%",
		sorter: (a, b) => a.mensagemPol.localeCompare(b.mensagemPol)
	},
	{    
		title: "Status Monitoramento",
		dataIndex: "descStatusMonitoramento",
		align: "left",
		scopedSlots: { customRender: "descStatusMonitoramento" },
		width: "20%",
		sorter: (a, b) => a.descStatusMonitoramento.localeCompare(b.descStatusMonitoramento)
	},
	{
		title: "Data Cadastro",
		dataIndex: "dataCadastro",
        align: "center",
		width: "12%",
        scopedSlots: { customRender: "dataCadastro" },
		sorter: (a, b) => moment(a.dataCadastro) - moment(b.dataCadastro),
		customCell:(record, index)=>{
	    return{
            	style: {background: (record.statusMonitoramento == 4 && Helpers.dateDiff(new Date(record.dataUltimaAlteracao.replace('T', ' ')), new Date())) > 2 ? "red" : "", 
						color: (record.statusMonitoramento == 4 && Helpers.dateDiff(new Date(record.dataUltimaAlteracao.replace('T', ' ')), new Date())) > 2 ? "white" : "", 
				},
			}
		}
	},
	{
		title: "Data Alteração",
		dataIndex: "dataUltimaAlteracao",
        align: "center",
		width: "12%",
        scopedSlots: { customRender: "dataUltimaAlteracao" },
		sorter: (a, b) => moment(a.dataUltimaAlteracao) - moment(b.dataUltimaAlteracao),
		customCell:(record, index)=>{
	    return{
            	style: {background: (record.statusMonitoramento == 4 && Helpers.dateDiff(new Date(record.dataUltimaAlteracao.replace('T', ' ')), new Date())) > 2 ? "red" : "", 
						color: (record.statusMonitoramento == 4 && Helpers.dateDiff(new Date(record.dataUltimaAlteracao.replace('T', ' ')), new Date())) > 2 ? "white" : "", 
				},
			}
		}
	},
	{
		key: "IdContrato",
		title: "",
		dataIndex: "editar",
		align: "center",
		//width: "",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsHistoricoContrato = [
	{    
		title: "Data Historico",
		dataIndex: "dataHistorico",
		align: "left",
		//width: "12%",
        scopedSlots: { customRender: "dataHistorico" },
		sorter: (a, b) => moment(a.dataHistorico) - moment(b.dataHistorico),
	},
	{    
		title: "Login",
		dataIndex: "login",
		align: "left",
		scopedSlots: { customRender: "login" },
		//width: "20%",
		sorter: (a, b) => a.login.localeCompare(b.login)
	},
	{    
		title: "Senha",
		dataIndex: "senha",
		align: "left",
		scopedSlots: { customRender: "senha" },
		//width: "30%",
		sorter: (a, b) => a.senha.localeCompare(b.senha)
	},
	{    
		title: "Image64 Autenticação",
		dataIndex: "image64Autenticacao",
		align: "left",
		scopedSlots: { customRender: "image64Autenticacao" },
		//width: "30%",		
		sorter: (a, b) => a.image64Autenticacao.localeCompare(b.image64Autenticacao)
	},
	{
		title: "Situação",
		dataIndex: "status",
		sorter: (a, b) => a.status - b.status,
		align: "center",
		//width: "7%",
		scopedSlots: { customRender: "status" }
	},
	{    
		title: "Mensagem Pol",
		dataIndex: "mensagemPol",
		align: "left",
		scopedSlots: { customRender: "mensagemPol" },
		//width: "50%",
		sorter: (a, b) => a.mensagemPol.localeCompare(b.mensagemPol)
	},
	{    
		title: "Usuário Alteração",
		dataIndex: "usuarioAlteracao",
		align: "left",
		scopedSlots: { customRender: "usuarioAlteracao" },
		//width: "30%",
		sorter: (a, b) => a.usuarioAlteracao.localeCompare(b.usuarioAlteracao)
	},
	{    
		title: "Data Alteração",
		dataIndex: "dataUltimaAlteracao",
		align: "left",
		//width: "12%",
        scopedSlots: { customRender: "dataUltimaAlteracao" },
		sorter: (a, b) => moment(a.dataUltimaAlteracao) - moment(b.dataUltimaAlteracao),
	},
	{    
		title: "Status Monitoramento",
		dataIndex: "descricaoStatusMonitoramento",
		align: "left",
		scopedSlots: { customRender: "descricaoStatusMonitoramento" },
		//width: "15%",
		sorter: (a, b) => a.descricaoStatusMonitoramento.localeCompare(b.descricaoStatusMonitoramento)
	},
];

export default {	
	name: "controleContrato",
	data() {
		return {
			idTela: 5,
			data: [],
			dataHistorico: [],
			pagination: {},
			paginationHistorico: {},
			loading: false,
			columnsAgrupCliente,
			columnsAgrupUsuario,
			columnsAgrupPerfilTribunal,
			columnsContrato,
			columnsHistoricoContrato,
			clientes:[],			
			usuarios:[],
			perfisTribunal:[],
			valueCliente: null,
			valueUsuario: null,
			valuePerfilTribunal: null,
			valueStatusMonitoramento: null,
		};
	},
	mounted() {
		this.recuperarClientes();
	},
	computed: {
		windowSizeScroll() {					
			if (window.outerHeight >= 999)
				return { x: 3000, y: 450 };
			else if (window.outerHeight >= 800 && window.outerHeight < 999)
				return { x: 3000, y: 400 };
			else if (window.outerHeight >= 700 && window.outerHeight < 799)
				return { x: 3000, y: 350 };
			else if (window.outerHeight >= 600 && window.outerHeight < 699)
				return { x: 3000, y: 300 };
			else if (window.outerHeight >= 500 && window.outerHeight < 599)
				return { x: 3000, y: 250 };
		},
	},
	methods: {
		handleClienteChange(value) {
			this.data = [];
			this.usuarios = [];
			this.valueUsuario = null;
			this.perfisTribunal = [];
			this.valuePerfilTribunal = null;
			this.valueStatusMonitoramento = null;
			this.valueCliente = value;
			this.recuperarUsuario(value);
		},
		handleUsuarioChange(value) {
			this.data = [];
			this.perfisTribunal = [];
			this.valuePerfilTribunal = null;
			this.valueStatusMonitoramento = null;
			this.valueUsuario = value;
			this.recuperarPerfilTribunal(value);
		},
		handlePerfilTribunalChange(value) {
			this.data = [];
			this.valuePerfilTribunal = value;
		},
		handleStatusMonitoramentoChange(value) {
			this.data = [];
			this.valueStatusMonitoramento = value;
		},
		recuperarClientes() {
			IntimacaoWebApi.getListarClientes().then(res => {
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Contrato", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Contrato", res.data.result);
				} else {
					this.clientes = res.data.result;
				}
			});
		},
		recuperarUsuario(idCliente) {
			if (idCliente != undefined && idCliente != null){
				IntimacaoWebApi.getUsuarioCliente(idCliente).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Controle Contrato", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Controle Contrato", res.data.result);
					} else {
						this.usuarios = res.data.result;
					}
				});
			}
		},
		recuperarPerfilTribunal(idUsuario) {
			if (idUsuario != undefined && idUsuario != null){
				IntimacaoWebApi.getPerfilTribunalExibicaoUsuario(idUsuario).then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Controle Contrato", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Controle Contrato", res.data.result);
					} else {
						this.perfisTribunal = res.data.result;
					}
				});
			}
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
		},
		handleTableHistoricoChange(pagination, filters, sorter) {
			const pager = { ...this.paginationHistorico };
			pager.current = pagination.current;
			this.paginationHistorico = pager;
		},
		pesquisar(reprocessar = false) {

			if (reprocessar == false){
				this.data = [];
			}
					
			this.loading = true;
			let filtro = { idCLiente: this.valueCliente != null ? this.valueCliente : 0,
						   idUsuario: this.valueUsuario != null ? this.valueUsuario : 0,
						   idPerfilTribunal: this.valuePerfilTribunal != null ? this.valuePerfilTribunal : 0,
						   statusMonitContrato: this.valueStatusMonitoramento != null ? parseInt(this.valueStatusMonitoramento) : -1};
			IntimacaoWebApi.controleContratos(filtro).then(res => {
				this.loading = false;				
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Contrato", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Contrato", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {				
				this.loading = false;
				showNotificationError(this, "Controle Contrato", "Erro Controle Contrato.");
			});
		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		handleOkRejeitar(e) {
			const _this = this;
			const x = _this.$createElement;
			this.$confirm({					
				content: h => <div style="font-size: 16px; color: #000000d9;">Deseja REJEITAR essa credencial ?</div>,
				okText: 'Sim',        			
				cancelText: 'Não',
				width: '25%',
				onOk() {
					_this.rejeitarCredencial(e.idContrato);
				},
				onCancel() {},
			});	
		},		
		handleOKHistorico(contrato) {
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.historicoContrato(contrato.idPerfilTribunal, contrato.idProduto)
			.then(res => {
				this.$root.loadingSpinner = false;
				if (res.data.statusCode == 200) {					
					this.dataHistorico = res.data.result.map(h => {						
						return { ...h, image64Autenticacao: h.image64Autenticacao != undefined ? h.image64Autenticacao.substring(1,20) : ''}
					});
					this.paginationHistorico = { current: 1 };
					this.$refs.modalHistoricoFontes.showModal();
				} else
					showNotificationError(this, "Controle Contrato", res.data.errorMessage);
			})
			.catch(res => {
				this.$root.loadingSpinner = false;
				this.loading = false;
				showNotificationError(this, "Controle Contrato", "Erro ao tentar pegar Histórico Contrato.");
			});		
		},
		// handleCancel() {
		// 	this.$refs.modalHistoricoFontes.handleCancel();
		// },
		handleOkReprocessar(e) {
			const _this = this;
			const x = _this.$createElement;
			this.$confirm({					
				content: h => <div style="font-size: 16px; color: #000000d9;">Deseja REPROCESSAR essa credencial ?</div>,
				okText: 'Sim',        			
				cancelText: 'Não',
				width: '25%',
				onOk() {
					_this.reprocessarCredencial(e.idContrato);
				},
				onCancel() {},
			});
		},
		handleOkSetErroLogin(e) {
			const _this = this;
			const x = _this.$createElement;
			this.$confirm({					
				content: h => <div style="font-size: 16px; color: #000000d9;">Deseja INVALIDAR essa credencial ?</div>,
				okText: 'Sim',        			
				cancelText: 'Não',
				width: '25%',
				onOk() {
					_this.setErroLoginCredencial(e.idContrato);
				},
				onCancel() {},
			});
		},
		rejeitarCredencial(idContrato) {
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.rejeitarCredencial(idContrato, this.$store.state.auth.idUser)
			.then(res => {
				this.$root.loadingSpinner = false;
				if (res.data.statusCode == 200) {
					this.pesquisar(true);
					showNotificationSucess(this, "Rejeitar credencial", res.data.result);
				} else
					showNotificationError(this, "Rejeitar credencial", res.data.errorMessage);
			})
			.catch(res => {
				this.$root.loadingSpinner = false;
				this.loading = false;
				showNotificationError(this, "Rejeitar credencial", "Erro ao tentar rejeitar credencial.");
			});
		},
		reprocessarCredencial(idContrato) {
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.reprocessarCredencial(idContrato, this.$store.state.auth.idUser)
			.then(res => {
				this.$root.loadingSpinner = false;
				if (res.data.statusCode == 200) {
					this.pesquisar(true);
					showNotificationSucess(this, "Reprocessar credencial", res.data.result);
				} else
					showNotificationError(this, "Reprocessar credencial", res.data.errorMessage);
			})
			.catch(res => {
				this.$root.loadingSpinner = false;
				this.loading = false;
				showNotificationError(this, "Reprocessar credencial", "Erro ao tentar reprocessar credencial.");
			});
		},
		setErroLoginCredencial(idContrato) {
			this.$root.loadingSpinner = true;
			IntimacaoWebApi.setErroLoginCredencial(idContrato, this.$store.state.auth.idUser)
			.then(res => {
				this.$root.loadingSpinner = false;
				if (res.data.statusCode == 200) {
					this.pesquisar(true);
					showNotificationSucess(this, "Invalidar credencial", res.data.result);
				} else
					showNotificationError(this, "Invalidar credencial", res.data.errorMessage);
			})
			.catch(res => {
				this.$root.loadingSpinner = false;
				this.loading = false;
				showNotificationError(this, "Invalidar credencial", "Erro ao tentar invalidar credencial.");
			});
		}
	},
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
</style>

<style>
</style>